var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTires(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_31",
    "data-name": "Group 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.668,
    height: 91.6,
    viewBox: "0 0 107.668 91.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 107.668,
    height: 91.6,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M50.675,36.069c-2.485-1.734-6.882-1.9-11.413-.464v9.7c4.954-1.4,9.8-1.061,12.705.967a7.1,7.1,0,0,1,.6.47V39.7a4.213,4.213,0,0,0-1.893-3.634",
    transform: "translate(26.004 22.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M50.675,43.322c-2.485-1.734-6.882-1.9-11.413-.465v9.7c4.954-1.4,9.8-1.061,12.705.967a7.45,7.45,0,0,1,.6.47V46.956a4.213,4.213,0,0,0-1.893-3.634",
    transform: "translate(26.004 27.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M50.675,28.817c-2.485-1.735-6.882-1.9-11.413-.465v9.7c4.954-1.4,9.8-1.061,12.705.967.213.15.412.306.6.469V32.451a4.213,4.213,0,0,0-1.893-3.634",
    transform: "translate(26.004 18.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M50.675,14.312c-2.485-1.734-6.882-1.9-11.413-.464v9.7c4.954-1.4,9.8-1.061,12.705.967a7.449,7.449,0,0,1,.6.47V17.946a4.213,4.213,0,0,0-1.893-3.634",
    transform: "translate(26.004 8.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 11.277,
    height: 91.6,
    transform: "translate(80.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M50.675,7.06c-2.485-1.735-6.882-1.9-11.413-.465v9.7c4.954-1.4,9.8-1.061,12.705.967a7.434,7.434,0,0,1,.6.469V10.694A4.213,4.213,0,0,0,50.675,7.06",
    transform: "translate(26.004 3.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M50.675,21.565c-2.485-1.734-6.882-1.9-11.413-.465v9.7c4.954-1.4,9.8-1.061,12.705.967a7.093,7.093,0,0,1,.6.47V25.2a4.213,4.213,0,0,0-1.893-3.634",
    transform: "translate(26.004 13.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M58.658,43.322a4.213,4.213,0,0,0-1.893,3.634V54a7.452,7.452,0,0,1,.6-.47c2.906-2.028,7.751-2.365,12.705-.967v-9.7c-4.531-1.43-8.928-1.268-11.413.465",
    transform: "translate(37.596 27.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M58.658,14.312a4.213,4.213,0,0,0-1.893,3.634v7.043a7.45,7.45,0,0,1,.6-.47c2.906-2.028,7.751-2.365,12.705-.967v-9.7c-4.531-1.431-8.928-1.27-11.413.464",
    transform: "translate(37.596 8.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M58.658,36.069A4.213,4.213,0,0,0,56.765,39.7v7.043a7.1,7.1,0,0,1,.6-.47c2.906-2.028,7.751-2.365,12.705-.967v-9.7c-4.531-1.431-8.928-1.27-11.413.464",
    transform: "translate(37.596 22.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M39.262,5.946V7.971c4.954-1.4,9.8-1.062,12.705.967a7.433,7.433,0,0,1,.6.469V0H46.85c-4.191,0-7.588,2.661-7.588,5.946",
    transform: "translate(26.004 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M50.675,50.575c-2.485-1.735-6.882-1.9-11.413-.465v3c0,3.283,3.4,5.946,7.588,5.946h5.718V54.209a4.213,4.213,0,0,0-1.893-3.634",
    transform: "translate(26.004 32.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M58.658,50.575a4.213,4.213,0,0,0-1.893,3.634v4.842h5.718c4.191,0,7.588-2.663,7.588-5.946v-3c-4.531-1.43-8.928-1.268-11.413.465",
    transform: "translate(37.596 32.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M62.483,0H56.765V9.409a7.2,7.2,0,0,1,.6-.47c2.9-2.028,7.75-2.365,12.7-.967V5.946c0-3.285-3.4-5.946-7.588-5.946",
    transform: "translate(37.596 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M58.658,28.817a4.213,4.213,0,0,0-1.893,3.634v7.042c.19-.163.389-.319.6-.469,2.906-2.028,7.751-2.365,12.705-.967v-9.7c-4.531-1.43-8.928-1.268-11.413.465",
    transform: "translate(37.596 18.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M58.658,21.565A4.213,4.213,0,0,0,56.765,25.2v7.043a7.1,7.1,0,0,1,.6-.47c2.906-2.028,7.751-2.365,12.705-.967V21.1c-4.531-1.43-8.928-1.268-11.413.465",
    transform: "translate(37.596 13.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M58.658,7.06a4.213,4.213,0,0,0-1.893,3.634v7.042a7.435,7.435,0,0,1,.6-.469c2.906-2.028,7.751-2.365,12.705-.967v-9.7c-4.531-1.43-8.928-1.268-11.413.465",
    transform: "translate(37.596 3.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M63.01,10.951V5.946a6.958,6.958,0,0,1,.439-2.42,45.8,45.8,0,1,0,0,84.547,6.965,6.965,0,0,1-.439-2.42V77.008a35.636,35.636,0,1,1,0-62.418Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M57.942,24.717V12.463A33.092,33.092,0,0,0,17.337,64.127,33.143,33.143,0,0,0,57.942,69V63.519A28.526,28.526,0,0,1,49.577,67.9a3.318,3.318,0,0,1-4.334-3.165V53.77a4.962,4.962,0,0,1,6.495-4.719l6.2,2.016V41.58l-3.416-1.109a4.963,4.963,0,0,1-2.48-7.637ZM12.164,40.777v-.045a28.422,28.422,0,0,1,5.431-16.741,3.326,3.326,0,0,1,5.388-.015l6.438,8.858a4.963,4.963,0,0,1-2.482,7.637l-10.469,3.4a3.283,3.283,0,0,1-4.305-3.1M36.222,64.732A3.318,3.318,0,0,1,31.889,67.9,28.671,28.671,0,0,1,17.672,57.576a3.327,3.327,0,0,1,1.639-5.142L29.726,49.05a4.963,4.963,0,0,1,6.5,4.719ZM51.191,18.661l-6.445,8.87a4.962,4.962,0,0,1-8.029,0l-6.443-8.87a3.326,3.326,0,0,1,1.682-5.12,28.6,28.6,0,0,1,17.552,0,3.327,3.327,0,0,1,1.682,5.12",
    transform: "translate(5.068 5.068)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTires);
export default __webpack_public_path__ + "static/media/tires.bb0073edd70bb4ffe8feb6f962c6133d.svg";
export { ForwardRef as ReactComponent };